const DEFAULT_BASE_FONT_SIZE = 16;

export default function parseFontSizeToPx(
  fontSize,
  fallbackSize = DEFAULT_BASE_FONT_SIZE,
  baseFontSize = DEFAULT_BASE_FONT_SIZE,
) {
  if (typeof fontSize === 'number' && !Number.isNaN(fontSize)) {
    return fontSize;
  }

  if (typeof fontSize === 'string') {
    const trimmed = fontSize.trim();

    if (trimmed.endsWith('rem')) {
      const remValue = parseFloat(trimmed);
      return Number.isNaN(remValue) ? fallbackSize : remValue * baseFontSize;
    }

    const pxValue = parseFloat(trimmed);
    return Number.isNaN(pxValue) ? fallbackSize : pxValue;
  }

  return fallbackSize;
}
